import styled from 'styled-components';
import { getSpacingToken, getToken, Size, Sized } from '@optimus-web/common';
import { getInputContainerHeight, getInputPadding } from '../Input/getInputStyles';

export const ContainerElement = styled.div<Sized>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: ${(props) => getSpacingToken(props.size === 'small' ? '100' : '200')}px;
    padding-right: ${(props) => getSpacingToken(props.size === 'small' ? '100' : '200')}px;

    div {
        padding-left: 0;
        padding-right: 0;
    }

    input {
        text-align: left;
        box-sizing: border-box;
        padding-left: 0;
        padding-right: 0;
    }
`;

export const NumericFormatWrapper = styled.div`
    width: 100%;
    margin-left: ${getSpacingToken('50')}px;
`;

export const FlexInputContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const CounterButtonsWrapper = styled.div<{ inputSize: Size }>`
    display: flex;
    align-items: center;
    height: calc(${getInputContainerHeight}px - ${getToken('borderWidth150')}px * 2);
    padding-top: ${(inputSize) => getInputPadding(inputSize)}px;
    padding-bottom: calc(${(inputSize) => getInputPadding(inputSize)}px - 1px);
    box-sizing: border-box;
    margin-left: ${getSpacingToken('150')}px;
`;

export const CounterButtonWrapper = styled.span<{ disabled?: boolean; isPlusButton?: boolean }>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'auto')};
    display: flex;
    margin-left: ${({ isPlusButton }) => (isPlusButton ? getSpacingToken('100') : 0)}px;
    margin-right: ${({ isPlusButton }) => (isPlusButton ? 0 : getSpacingToken('100'))}px;
`;
